import { Component, OnInit } from "@angular/core";
import { Globals } from "../globals";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

@Component({
  selector: "app-administrador-conflictos",
  templateUrl: "./administrador-conflictos.component.html",
  styleUrls: ["./administrador-conflictos.component.css"]
})
export class AdministradorConflictosComponent implements OnInit {
  titulo;
  botonNuevoConflicto;
  botonEditarConflicto;
  faQuestion = faQuestionCircle;

  constructor(public globals: Globals) {}

  ngOnInit() {
    //////conole.log(this.globals.lenguaje);
    if (this.globals.lenguaje == "es" || this.globals.lenguaje == "ESPANOL" || this.globals.lenguaje == "ESPAÑOL") {
      this.titulo = "Actualización de Conflictos";
      this.botonNuevoConflicto = "Crear Nuevo Conflicto";
      this.botonEditarConflicto = "Editar Conflicto";
    } else {
      this.globals.lenguaje = "en";
      this.titulo = "Conflict Update";
      this.botonNuevoConflicto = "Create New Conflict";
      this.botonEditarConflicto = "Edit Conflict";
    }
  }

  CrearNuevoConflicto() {
    this.globals.ConflictosVarGlobal = "nuevo";
    this.globals.conflictosPreguntaGlobal = false;
    this.globals.lugarConflicto=2
  }

  EditarConflicto() {
    this.globals.ConflictosVarGlobal = "editar";
    this.globals.conflictosPreguntaGlobal = false;
    this.globals.lugarConflicto=2
  }

  tituloInfo = {
    es: `<h5>Guía General Encuesta Conflictos de Interés</h5>`,
    en: `<h5>General Guide - Conflict of Interests Survey</h5>`
  };

  informacion = {
    es: `<h5><u>1. Definiciones e Interpretación de Conflicto de Interés: </u></h5>
  <p align="justify">
    Un conflicto de interés es aquella situación en la cual una persona que desempeña una función para FRONTERA tiene un
    interés privado, personal o profesional que puede afectar su juicio y ejercer influencia en el ejercicio de sus
    deberes.
  </p>
  <p align="justify">
    Los conflictos de interés son reales, percibidos o potenciales. Un conflicto de interés real ocurre cuando la
    decisión que toma una persona que desempeña una función para FRONTERA, tiene un impacto favorable sobre un interés
    privado (personal o profesional). Un conflicto de interés percibido es aquella situación en la que cualquier persona
    que conoce los hechos, consideraría que existe un conflicto de interés, sea o no el caso. Un conflicto de interés
    potencial existe cuando la decisión que toma hoy una persona que desempeña una función para FRONTERA, podría tener
    un impacto favorable sobre un interés privado en el futuro.
  </p>

  <h5><u>2. Ejemplos y escenarios de Conflicto de Interés: </u></h5>
  <p align="justify">Las siguientes situaciones son ejemplos de conflictos de interés:</p>
  <ul>
  <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Involucramiento en actividades comerciales o personales que directa o indirectamente están en conflicto o impactan
      la Compañía o sus intereses de cualquier forma.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Relaciones con funcionarios públicos o entidades que son propiedad del Estado.</li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Asociación con personas o empresas que podrían, de cualquier forma, beneficiarse con las decisiones de la
      Compañía.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Uso de cualquier información confidencial (información que no está disponible al público de forma general) de la
      Compañía para beneficio personal.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Ejercer influencia sobre las políticas o decisiones de la Compañía para beneficio personal o de un tercero.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Usar el vínculo que se tiene con la Compañía para obtener ganancia, intentar obtener ganancia, o cualquier
      beneficio personal o para familiares o amigos.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Dar asesoría a la Compañía buscando impactar a otras organizaciones con las cuales la Compañía está involucrada.
    </li>

    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Invertir en cualquier competidor de la Compañía, o cualquier empresa que hace negocios o que busca hacer negocios
      con la Compañía, distinto a inversiones relativamente menores en títulos valores poseídos por el público en
      general.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Trabajar para, o a nombre de, cualquiera de las empresas mencionadas en el punto anterior.</li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Adjudicar los negocios de la Compañía a familiares o amigos, o trabajar en un proyecto de la Compañía que tendrá
      un impacto directo sobre los intereses de familiares o amigos.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Usar los recursos de la Compañía, incluyendo teléfonos, e-mail e Internet, para resolver asuntos personales, salvo
      que dicho uso sea razonable y no interrumpa el flujo de trabajo ni genere costos adicionales a la Compañía.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Participar en las actividades regulatorias u otras actividades de un ente comunitario o gubernamental que tengan
      un impacto directo sobre los negocios de la Compañía, salvo que esté debidamente autorizado.
    </li>

    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Contratar o supervisar a un familiar o amigo.</li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Ejercer el cargo de director, funcionario, socio, consultor, o cualquier otro rol significativo, en cualquier
      competidor, proveedor, o cliente de la Compañía, o en cualquier entidad u organización con la cual la Compañía
      negocia o busca negociar.
    </li>
    <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
      Actuar como corredor o intermediario para beneficio de un tercero en las transacciones que involucran a la
      Compañía.
    </li>
  </ul>`,
    en: `<h5><u>1. Definitions and Interpretation: </u></h5>
    <p align="justify">
      A conflict of interest is defined as a situation where Personnel have a private, personal, professional or
      vested interest sufficient to influence the exercise of their duties at the Corporation. If this competing
      interest can potentially interfere with the proper exercise of judgment, then a conflict of interest exists.
    </p>
    <p align="justify">
      Conflicts of interest might be actual, perceived or potential. An actual conflict of interest occurs when
      advice given or an action taken has a direct and predictable impact on a private, personal, professional or
      vested interest. A perceived conflict of interest occurs when a reasonable person, knowing the facts, would
      consider that a conflict of interest may exist, whether or not this is the case. A potential conflict of
      interest exists when advice given or an action taken might have an impact on a private, personal,
      professional or vested interest in the future.
    </p>

    <h5><u>2. Examples and some scenarios of a Conflict of Interest: </u></h5>
    <p align="justify">
      Examples of circumstances that can give rise to a conflict of interest for Personnel include (but are not
      limited to):
    </p>
    <ul>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Involvement in business or personal activities that directly or indirectly conflict with or impact the
        Corporation or its interests in any way;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Relationships with government officials or state-owned entities;</li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Association with individuals or businesses that may in any way benefit from decisions of the Corporation;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Use of any confidential information (i.e., information that is not generally available to the public) of
        the Corporation for personal benefit;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Attempts to influence the Corporation’s policies or decisions for personal benefit or the benefit of a
        third party;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Using association with the Corporation to gain, or attempt to gain, any personal benefit or benefit for
        family or friends;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Providing advice to the Corporation that will impact other organizations with which Personnel are
        involved.
      </li>
    </ul>

    <p align="justify">
      Some scenarios that may pose potential conflict of interest problems include, but are not limited to, the
      following:
    </p>

    <ul>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Investing in any competitor company to the Corporation, or any company doing or seeking to do business
        with the Corporation, other than relatively small investments in securities widely held by the general
        public;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Working for, or on behalf of, any company referred to in the preceding bullet;</li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Placing the Corporation’s business with relatives or friends, or working on a project of the Corporation
        that will have a direct impact on the financial interests of relatives or friends;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Using the Corporation’s resources, including telephones, e-mail and Internet, for dealing with personal
        matters, unless such usage is reasonable and does not disrupt the flow of work or result in additional
        costs for the Corporation;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Borrowing money from companies doing or seeking to do business with the Corporation other than on
        generally available terms;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Participating in the regulatory or other activities of a community or governmental body that have a direct
        impact on the business of the Corporation unless authorized by the Corporation;
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">Hiring or supervising a relative or friend;</li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Serving as a director, officer, partner, consultant, or in any other significant role, in any competitor,
        supplier, or customer of the Corporation, or any entity or organization with which the Corporation does
        business or seeks to do business; and
      </li>
      <li style="margin-left:auto; margin-right:auto; margin:0px auto; text-align:justify">
        Acting as a broker, finder or other intermediary for the benefit of a third party in transactions
        involving the Corporation or its interests.
      </li>
    </ul>`
  };

  informacionEncuesta() {
    Swal.fire({
      title: this.tituloInfo[this.globals.lenguaje],
      type: "info",
      html: this.informacion[this.globals.lenguaje],
      width: '800px'
    });
  }

  Es(){ 
    this.globals.lenguaje = "es";
    this.ngOnInit();
  }

  En(){    
    this.globals.lenguaje = "en";
    this.ngOnInit();
  }


}
